import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import AppText, { FormHeader } from "../../../components/Core/AppText/AppText";
import Button from "../../../components/Core/Button/Button";
import Modal from "../../../components/Core/Modal/Modal";
import TextArea from "../../../components/Core/TextArea/TextArea";
import Flex from "../../../components/Layout/Flex";

interface Props {
	onClose: () => void;
	onSubmit: (msg: string) => void;
	loading?: boolean;
}

const NotifyConsultantsModal: React.FC<Props> = ({ onClose, onSubmit, loading }) => {
	const { t } = useTranslation();
	const [message, setMessage] = useState("");

	return (
		<Modal onClose={onClose}>
			<StyledModal>
				<FormHeader margin="0 0 1rem 0">{t("sendNotificationModal.title")}</FormHeader>
				<AppText margin="1rem 0">{t("sendNotificationModal.info")}</AppText>
				<TextArea
					placeholder={t("sendNotificationModal.placeholder")}
					containerMargin="1rem 0"
					onChangeText={setMessage}
					value={message}
				/>
				<Flex justifyContent="flex-end" alignItems="flex-start">
					<Button
						margin="0 0.5rem"
						onClick={() => onSubmit(message)}
						disabled={!message}
						loading={loading}
					>
						{t("SEND")}
					</Button>
					<Button backgroundColor="transparent" textColor="grayTextDark" onClick={onClose}>
						{t("CANCEL")}
					</Button>
				</Flex>
			</StyledModal>
		</Modal>
	);
};

export default NotifyConsultantsModal;

const StyledModal = styled.div``;
